/**
 * @export
 * @class PromotionBannerPC
 * 마케팅 배너 (PC 전용)
 */
import store from '../../store';

export default class PromotionBannerPC {
  constructor() {
    this.sWrapper = '_wrapPromotionBanner';
    this.welWrapper = $(`#${this.sWrapper}`);

    store.subscribe(this.render.bind(this));
  }

  setEvent() {
    this.welWrapper.on('click', '.prev', () => {
      this.move('prev');
    });
    this.welWrapper.on('click', '.next', () => {
      this.move('next');
    });

    if (this.bannerList.length > 1) {
      setInterval(() => {
        this.move('next');
      }, 3000);
    }
  }

  clearEvent() {
    this.welWrapper.off('click', '.prev');
    this.welWrapper.off('click', '.next');
  }

  move(sMoveType) {
    let nCurrent = parseInt($('#_naviCount strong').html(), 10);
    const nFull = $('#_naviCount em').html();

    if (sMoveType === 'prev') {
      nCurrent -= 1;
    } else {
      nCurrent += 1;
    }

    if (nCurrent === 0) {
      nCurrent = nFull;
    }

    if (nCurrent > nFull) {
      nCurrent = 1;
    }

    this.show(nCurrent, true);
    $('#_naviCount strong').html(nCurrent);
  }

  render() {
    /* eslint no-multi-assign: off */
    const bannerData = store.getState().fetchApi.promotionBanner;
    if (
      !bannerData ||
      (bannerData && !bannerData.configInfo.length) ||
      this.bannerList
    )
      return;
    const bannerList = (this.bannerList =
      bannerData.configInfo[0].configDataList[0].templateConfigComponents);

    const sHtml = `<div class="ct_wrp">
                <div class="banner">
                    <ul class="lst">
                    ${bannerList
                      .map((item, i) => {
                        const planId = /\/(\w+)$/g.exec(item.landingInfo);
                        return `<li>
                                    ${
                                      item.landingInfo
                                        ? `<a href="${
                                            item.landingInfo
                                          }" data-tlarea="M123EV" data-tlord="${i +
                                            1}" data-tldimension="title:${
                                            item.imageAltText
                                          }__plan_id:${planId[1]}" ${
                                            item.newWindowYn === 'Y'
                                              ? 'target="_blank"'
                                              : ''
                                          }>
                                                <img src="${
                                                  item.pcImageUrl
                                                }" alt="${item.imageAltText}">
                                            </a>`
                                        : `<img src="${item.pcImageUrl}" alt="${item.imageAltText}">`
                                    }
                                </li>`;
                      })
                      .join('')}
                    </ul>
                </div>
                ${
                  bannerList.length > 1
                    ? `<div class="ctrl">
                            <span class="cnt" id="_naviCount"><strong>1</strong>/<em>${bannerList.length}</em></span>
                            <button class="prev"><i>이전</i></button>
                            <button class="next"><i>다음</i></button>
                        </div>`
                    : ''
                }
            </div>`;
    this.welWrapper.html(sHtml).show();
    this.setEvent();
    this.show(1, false);
  }

  show(nIndex, bSetMinHeight) {
    this.welWrapper.css('minHeight', 0);
    const nHeight = this.welWrapper.find(`li:eq(${nIndex - 1})`).height();
    if (bSetMinHeight) {
      this.welWrapper.css('minHeight', nHeight);
    }
    this.welWrapper
      .find('li')
      .stop(true, true)
      .css('position', 'absolute')
      .fadeOut();
    this.welWrapper
      .find(`li:eq(${nIndex - 1})`)
      .css('position', 'relative')
      .fadeIn();
  }
}
